<!--
 * @Description: 账号管理-操作日志
 * @Date: 2020-11-06 16:38:28
-->
<template>
  <table-render ref="tableRender" :config="config" />
</template>

<script>
import tableRender from '@/components/tableRender';
import { operationLog as config } from './config';
export default {
  name: 'ProjectPersonnelManage',
  data() {
    return {
      config
    };
  },
  components: { tableRender },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  beforeDestroy() {}
};
</script>

<style scoped lang="scss"></style>
